module.exports = __webpack_public_path__ + "static/media/sdxl.764e3091.png";